import {ApiModel} from "./api.model";


export const CountModel = ApiModel.extend({
    props: {
        count: 'number',
    },
    extraProperties: 'reject'
});
